import requester from '@/lib/axios';
import { FlashcardQuestion, FlashcardQuestionDTO } from '@/models/Question';

const baseUrl = 'flashcard-activity';

export const createFlashcardQuestion = async (body: FlashcardQuestionDTO) => {
  const { data: flashcardQuestion } = await requester().post<FlashcardQuestion>(
    `${baseUrl}/`,
    body,
  );

  return flashcardQuestion;
}

export const getFlashcardQuestion = async (id: number) => {
  const { data: flashcardQuestion } = await requester().get<FlashcardQuestion>(
    `${baseUrl}/${id}/`,
  );

  return flashcardQuestion;
};

export const deleteFlashcardQuestion = async (id: number) => {
  await requester().delete<FlashcardQuestion>(`${baseUrl}/${id}/`);
};

export const updateFlashcardQuestion = async (
  id: number,
  changes: FlashcardQuestionDTO,
) => {
  const { data: flashcardQuestion } = await requester().patch<FlashcardQuestion>(
    `${baseUrl}/${id}/`,
    changes,
  );

  return flashcardQuestion;
}


